export default function filterBookings(bookings, appliedFilters) {
  const defaultFilter = () => true;

  const filterFunctions = Object.entries(appliedFilters).map(([k, v]) => {
    if (Array.isArray(v) && v.length === 0) {
      return defaultFilter;
    }

    switch (k) {
      case "includeInternal":
        if (!v) {
          return b => b.direction !== "internal";
        }
        return defaultFilter;
      case "direction":
        return b => {
          const values = v.map(({ value }) => value);
          return values.includes(b.direction);
        };
      case "status":
        return b => {
          const values = v.map(({ value }) => value);
          const bookingStatus = b.haulier === null ? "proposed" : b.status;
          return values.includes(bookingStatus);
        };
      case "haulier":
        return b => {
          if (!b.haulier) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.haulier.id);
        };
      case "sendingSite":
        return b => {
          if (!b.sendingSite) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.sendingSite.id);
        };
      case "receivingSite":
        return b => {
          if (!b.receivingSite) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.receivingSite.id);
        };
      case "loadType":
        return b => {
          if (!b.loadType) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.loadType);
        };
      case "trailerType":
        return b => {
          if (!b.trailerType) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.trailerType.id);
        };
      default:
        return defaultFilter;
    }
  });

  return bookings.filter(b => filterFunctions.every(af => af(b)));
}
